import { render, staticRenderFns } from "./BlockVideo.vue?vue&type=template&id=e28617b8&"
import script from "./BlockVideo.vue?vue&type=script&lang=js&"
export * from "./BlockVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports